import { SxProps, Theme } from '@mui/material';

export const panelStyles: SxProps<Theme> = {
    maxWidth: 520,
    mx: 'auto',
    py: 4,
};

export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    py: 8,
};

export const titleStyles: SxProps<Theme> = {
    fontWeight: 700,
    mb: 2,
};

export const summaryStyles: SxProps<Theme> = {
    fontWeight: 600,
    mb: 2,
};

export const instructionStyles: SxProps<Theme> = {
    color: 'text.secondary',
    mb: 3,
};

export const fieldStyles: SxProps<Theme> = {
    mb: 2,
};

export const alertStyles: SxProps<Theme> = {
    mb: 3,
};

export const actionsStyles: SxProps<Theme> = {
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap',
    alignItems: 'center',
};
